/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  UploadButton: function() { return /* reexport */ UploadButton; },
  UploadDropzone: function() { return /* reexport */ UploadDropzone; }
});

;// CONCATENATED MODULE: external "react"
var external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// CONCATENATED MODULE: external "lodash.isequal"
var external_lodash_isequal_namespaceObject = require("lodash.isequal");
var external_lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(external_lodash_isequal_namespaceObject);
;// CONCATENATED MODULE: ./src/hooks/UseObjectDep.ts


function useObjectDep(value) {
  var _a;
  var ref = (0,external_react_namespaceObject.useRef)();
  if (!external_lodash_isequal_default()(value, ref.current)) {
    ref.current = value;
  }
  return (_a = ref.current) !== null && _a !== void 0 ? _a : value;
}
;// CONCATENATED MODULE: ./src/hooks/UseAutoUpdatingOptions.ts
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function useAutoUpdatingOptions(options) {
  var _useState = (0,external_react_namespaceObject.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    methods = _useState2[0],
    setMethods = _useState2[1];
  var optionsDep = useObjectDep(options);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (methods !== undefined) {
      methods.updateConfig(options);
    }
  }, [optionsDep, methods]);
  return Object.assign(Object.assign({}, options), {
    onInit: function onInit(m) {
      if ((options === null || options === void 0 ? void 0 : options.onInit) !== undefined) {
        options.onInit(m);
      }
      setMethods(m);
    }
  });
}
;// CONCATENATED MODULE: external "@bytescale/upload-widget"
var upload_widget_namespaceObject = require("@bytescale/upload-widget");
;// CONCATENATED MODULE: ./src/UploadButton.tsx


var UploadButton = function UploadButton(_ref) {
  var options = _ref.options,
    onComplete = _ref.onComplete,
    onUpdate = _ref.onUpdate,
    children = _ref.children;
  var onUpdateParams = onUpdate === undefined ? {} : {
    onUpdate: onUpdate
  };
  var autoUpdatingOptions = useAutoUpdatingOptions(Object.assign(Object.assign({}, options), onUpdateParams));
  var onClick = function onClick(e) {
    e.preventDefault();
    upload_widget_namespaceObject.UploadWidget.open(autoUpdatingOptions).then(function (files) {
      if (onComplete !== undefined) {
        onComplete(files);
      }
    }, function (error) {
      return console.error("Uploader error.", error);
    });
  };
  return children({
    onClick: onClick
  });
};
;// CONCATENATED MODULE: ./src/hooks/UseElementRef.ts
function UseElementRef_slicedToArray(arr, i) { return UseElementRef_arrayWithHoles(arr) || UseElementRef_iterableToArrayLimit(arr, i) || UseElementRef_unsupportedIterableToArray(arr, i) || UseElementRef_nonIterableRest(); }
function UseElementRef_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UseElementRef_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UseElementRef_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UseElementRef_arrayLikeToArray(o, minLen); }
function UseElementRef_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UseElementRef_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UseElementRef_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Unlike 'useRef', 'useElementRef' will trigger a rerender when the reference is updated.
 */
function useElementRef() {
  var _useState = (0,external_react_namespaceObject.useState)(undefined),
    _useState2 = UseElementRef_slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var elementRef = (0,external_react_namespaceObject.useCallback)(function (e) {
    setElement(e !== null && e !== void 0 ? e : undefined);
  }, []);
  return [element, elementRef];
}
;// CONCATENATED MODULE: ./src/UploadDropzone.tsx
function UploadDropzone_slicedToArray(arr, i) { return UploadDropzone_arrayWithHoles(arr) || UploadDropzone_iterableToArrayLimit(arr, i) || UploadDropzone_unsupportedIterableToArray(arr, i) || UploadDropzone_nonIterableRest(); }
function UploadDropzone_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function UploadDropzone_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return UploadDropzone_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UploadDropzone_arrayLikeToArray(o, minLen); }
function UploadDropzone_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function UploadDropzone_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function UploadDropzone_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var UploadDropzone = function UploadDropzone(_ref) {
  var options = _ref.options,
    onComplete = _ref.onComplete,
    onUpdate = _ref.onUpdate,
    minWidth = _ref.minWidth,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  var _useElementRef = useElementRef(),
    _useElementRef2 = UploadDropzone_slicedToArray(_useElementRef, 2),
    element = _useElementRef2[0],
    elementRef = _useElementRef2[1];
  var classNameProp = className === undefined ? {} : {
    className: className
  };
  var onUpdateParams = onUpdate === undefined ? {} : {
    onUpdate: onUpdate
  };
  var autoUpdatingOptions = useAutoUpdatingOptions(Object.assign(Object.assign(Object.assign({}, options), onUpdateParams), {
    layout: "inline",
    container: element
  }));
  // Prevent React warning, while keeping rendering synchronous in the browser.
  if (typeof window !== "undefined") {
    (0,external_react_namespaceObject.useLayoutEffect)(function () {
      if (element !== undefined) {
        upload_widget_namespaceObject.UploadWidget.open(autoUpdatingOptions).then(function (files) {
          if (onComplete !== undefined) {
            onComplete(files);
          }
        }, function (error) {
          return console.error("Uploader error.", error);
        });
      }
    }, [element]);
  }
  return /*#__PURE__*/external_react_default().createElement("div", Object.assign({}, classNameProp, {
    ref: elementRef,
    style: {
      position: "relative",
      width: "100%",
      minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : "280px",
      maxWidth: width !== null && width !== void 0 ? width : "600px",
      height: height !== null && height !== void 0 ? height : "375px"
    }
  }));
};
;// CONCATENATED MODULE: ./src/index.ts


module.exports = __webpack_exports__;
/******/ })()
;